/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable import/prefer-default-export */
/**
 * Workbook feature related request structures are defined here
 */
export const API = {
  POST_PDF_EXPORT_URL: {
    path: '/organizations/:organizationId/visual-export?:query',
    method: 'POST',
  },
  POST_PDF_EXPORT: {
    path: '/organizations/:organizationId/visual-download',
    method: 'POST',
  },
  GET_JS_VISUAL_DATA: {
    path: '/organizations/:organizationId/data',
    method: 'POST',
  },
};

export const PACE_TABULAR_TITLE = 'Room Nights Pace By Channel Monthly Breakdown';
export const RATE_PLAN_TABULAR_TITLE = 'Rate Plan';
export const RATE_CATEGORY_TABULAR_TITLE = 'Rate Category';
export const ROOM_TYPE_TABULAR_TITLE = 'Room Type';
export const CONSORTIA_TABULAR_TITLE = 'Consortia';
export const IATA_TABULAR_TITLE = 'Travel Agency';

export const TABLE_MEASURES = 'measures';
export const COLUMN_DYNAMIC_MEASURE = 'dynamic_measure';
export const COLUMN_DYNAMIC_MEASURE_ST = 'dynamic_measure_st';

export const COLUMNS = [
  {
    table: 'measures',
    columns: 'rooms_night_pace_by_channel_monthly_breakdown',
  },
];

export const RATE_STAY_COLUMNS = [
  {
    table: 'measures',
    columns: 'rate_plan_stay',
  },
];

export const RATE_ARRIVAL_COLUMNS = [
  {
    table: 'measures',
    columns: 'rate_plan_arrival',
  },
];

export const ROOM_TYPE_COLUMNS = [
  {
    table: 'measures',
    columns: 'room_type_plan',
  },
];

export const RATE_CATEGORY_COLUMNS = [
  {
    table: 'measures',
    columns: 'rate_category_plan',
  },
];

export const CONSORTIA_COLUMNS = [
  {
    table: 'measures',
    columns: 'consortia',
  },
];
export const IATA_COLUMNS = [
  {
    table: 'measures',
    columns: 'IATA',
  },
];

export const PACE_TABLE_COLUMNS = [
  { id: 'year', label: 'Year', type: 'string', align: 'left' },
  { id: 'month', label: 'Month', type: 'number', align: 'left' },
  { id: 'channel', label: 'Channel', type: 'string', align: 'left' },
  { id: 'this_year_rooms', label: 'This Year', type: 'number', align: 'right' },
  { id: 'last_year_rooms', label: 'Last Year', type: 'number', align: 'right' },
  { id: 'YOY_rooms', label: 'YOY', type: 'number', align: 'right' },
  {
    id: 'last_year_month_end_rooms',
    label: 'Last Year Month End',
    type: 'number',
    align: 'right',
  },
  { id: 'TY_MTD_OTB', label: 'TY % MTD OTB', type: 'number', align: 'right' },
];

export const ROOM_TYPE_TABLE_COLUMNS = [
  { id: 'Room_code', label: 'Room Code', type: 'string', align: 'left' },
  { id: 'Room_type_name', label: 'Room Type Name', type: 'string', align: 'left' },
  { id: 'room_nights_cp', label: 'CP RN', type: 'number', align: 'right' },
  { id: 'room_nights_lp', label: 'LP RN', type: 'number', align: 'right' },
  {
    id: 'room_nights_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'cp_rsv', label: 'CP Rsv', type: 'number', align: 'right' },
  { id: 'lp_rsv', label: 'LP Rsv', type: 'number', align: 'right' },
  {
    id: 'reservation_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'total_revenue_cp', label: 'CP Rev', type: 'string', align: 'right' },
  { id: 'total_revenue_lp', label: 'LP Rev', type: 'string', align: 'right' },
  {
    id: 'total_revenue_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'ADR_cp', label: 'CP ADR', type: 'string', align: 'right' },
  { id: 'ADR_lp', label: 'LP ADR', type: 'string', align: 'right' },
  { id: 'ADR_percentage_change', label: '% Chg', type: 'string', align: 'right' },
  { id: 'ALOS_cp', label: 'CP Avg LoS', type: 'string', align: 'right' },
  { id: 'ALOS_lp', label: 'LP Avg Los', type: 'string', align: 'right' },
  { id: 'LeadTime_cp', label: 'CP Avg Lead', type: 'string', align: 'right' },
  { id: 'LeadTime_lp', label: 'LP Avg Lead', type: 'string', align: 'right' },
];

export const RATE_PLAN_TABLE_COLUMNS = [
  { id: 'Rate_code', label: 'Rate Code', type: 'string', align: 'left' },
  { id: 'Rate_type_name', label: 'Rate Name', type: 'string', align: 'left' },
  { id: 'room_nights_cp', label: 'CP RN', type: 'number', align: 'right' },
  { id: 'room_nights_lp', label: 'LP RN', type: 'number', align: 'right' },
  {
    id: 'room_nights_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'cp_rsv', label: 'CP Rsv', type: 'number', align: 'right' },
  { id: 'lp_rsv', label: 'LP Rsv', type: 'number', align: 'right' },
  {
    id: 'reservation_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'total_revenue_cp', label: 'CP Rev', type: 'string', align: 'right' },
  { id: 'total_revenue_lp', label: 'LP Rev', type: 'string', align: 'right' },
  {
    id: 'total_revenue_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'ADR_cp', label: 'CP ADR', type: 'string', align: 'right' },
  { id: 'ADR_lp', label: 'LP ADR', type: 'string', align: 'right' },
  { id: 'ADR_percentage_change', label: '% Chg', type: 'string', align: 'right' },
  { id: 'ALOS_cp', label: 'CP Avg LoS', type: 'string', align: 'right' },
  { id: 'ALOS_lp', label: 'LP Avg Los', type: 'string', align: 'right' },
  { id: 'LeadTime_cp', label: 'CP Avg Lead', type: 'string', align: 'right' },
  { id: 'LeadTime_lp', label: 'LP Avg Lead', type: 'string', align: 'right' },
];

export const RATE_CATEGORY_TABLE_COLUMNS = [
  { id: 'Rate_category', label: 'Rate Category', type: 'string', align: 'left' },
  { id: 'room_nights_cp', label: 'CP RN', type: 'number', align: 'right' },
  { id: 'room_nights_lp', label: 'LP RN', type: 'number', align: 'right' },
  {
    id: 'room_nights_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'cp_rsv', label: 'CP Rsv', type: 'number', align: 'right' },
  { id: 'lp_rsv', label: 'LP Rsv', type: 'number', align: 'right' },
  {
    id: 'reservation_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'total_revenue_cp', label: 'CP Rev', type: 'string', align: 'right' },
  { id: 'total_revenue_lp', label: 'LP Rev', type: 'string', align: 'right' },
  {
    id: 'total_revenue_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'ADR_cp', label: 'CP ADR', type: 'string', align: 'right' },
  { id: 'ADR_lp', label: 'LP ADR', type: 'string', align: 'right' },
  { id: 'ADR_percentage_change', label: '% Chg', type: 'string', align: 'right' },
  { id: 'ALOS_cp', label: 'CP Avg LoS', type: 'string', align: 'right' },
  { id: 'ALOS_lp', label: 'LP Avg Los', type: 'string', align: 'right' },
  { id: 'LeadTime_cp', label: 'CP Avg Lead', type: 'string', align: 'right' },
  { id: 'LeadTime_lp', label: 'LP Avg Lead', type: 'string', align: 'right' },
];

export const CONSORTIA_TABLE_COLUMNS = [
  { id: 'consortia', label: 'Consortia', type: 'string', align: 'left' },
  { id: 'room_nights_cp', label: 'CP RN', type: 'number', align: 'right' },
  { id: 'room_nights_lp', label: 'LP RN', type: 'number', align: 'right' },
  {
    id: 'room_nights_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'cp_rsv', label: 'CP Rsv', type: 'number', align: 'right' },
  { id: 'lp_rsv', label: 'LP Rsv', type: 'number', align: 'right' },
  {
    id: 'reservation_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'total_revenue_cp', label: 'CP Rev', type: 'string', align: 'right' },
  { id: 'total_revenue_lp', label: 'LP Rev', type: 'string', align: 'right' },
  {
    id: 'total_revenue_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'ADR_cp', label: 'CP ADR', type: 'string', align: 'right' },
  { id: 'ADR_lp', label: 'LP ADR', type: 'string', align: 'right' },
  { id: 'ADR_percentage_change', label: '% Chg', type: 'string', align: 'right' },
  { id: 'ALOS_cp', label: 'CP Avg LoS', type: 'string', align: 'right' },
  { id: 'ALOS_lp', label: 'LP Avg Los', type: 'string', align: 'right' },
  { id: 'LeadTime_cp', label: 'CP Avg Lead', type: 'string', align: 'right' },
  { id: 'LeadTime_lp', label: 'LP Avg Lead', type: 'string', align: 'right' },
];

export const IATA_TABLE_COLUMNS = [
  { id: 'travel_agency_name', label: 'Travel Agency Name', type: 'string', align: 'left' },
  { id: 'room_nights_cp', label: 'CP RN', type: 'number', align: 'right' },
  { id: 'room_nights_lp', label: 'LP RN', type: 'number', align: 'right' },
  {
    id: 'room_nights_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'cp_rsv', label: 'CP Rsv', type: 'number', align: 'right' },
  { id: 'lp_rsv', label: 'LP Rsv', type: 'number', align: 'right' },
  {
    id: 'reservation_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'total_revenue_cp', label: 'CP Rev', type: 'string', align: 'right' },
  { id: 'total_revenue_lp', label: 'LP Rev', type: 'string', align: 'right' },
  {
    id: 'total_revenue_percentage_change',
    label: '% Chg',
    type: 'string',
    align: 'right',
  },
  { id: 'ADR_cp', label: 'CP ADR', type: 'string', align: 'right' },
  { id: 'ADR_lp', label: 'LP ADR', type: 'string', align: 'right' },
  { id: 'ADR_percentage_change', label: '% Chg', type: 'string', align: 'right' },
  { id: 'ALOS_cp', label: 'CP Avg LoS', type: 'string', align: 'right' },
  { id: 'ALOS_lp', label: 'LP Avg Los', type: 'string', align: 'right' },
  { id: 'LeadTime_cp', label: 'CP Avg Lead', type: 'string', align: 'right' },
  { id: 'LeadTime_lp', label: 'LP Avg Lead', type: 'string', align: 'right' },
];

export const STAY_DATE_LOWER_FILTER = 'dynamic_stayDateFilter_lower';
export const STAY_DATE_UPPER_FILTER = 'dynamic_stayDateFilter_upper';

export const BOOKING_DATE_LOWER_FILTER = 'bookingDateFilter_lower';
export const BOOKING_DATE_UPPER_FILTER = 'bookingDateFilter_upper';

export const ARRIVAL_STAY_DATE_SWITCH_FILTER = 'arrival_staydate_switch';
export const PMS_FILTER = 'pmsFilter';
export const HOTEL_FILTER = 'hotelFilter';
export const PACE_VIEW_RANGE_FILTER = 'pace_view_range';

export const PACE_VIEW_RANGE_FILTER_VALUE = '12';

// rate tabular filters
export const DYNAMIC_STAY_DATE_FILTER_LOWER = 'dynamic_stayDateFilter_lower';
export const DYNAMIC_STAY_DATE_FILTER_UPPER = 'dynamic_stayDateFilter_upper';
export const DYNAMIC_COMPARISON_TIME_FILTER_STAY_DATE_LOWER =
  'dynamic_comparisonTimeFilterStayDate_lower';
export const DYNAMIC_COMPARISON_TIME_FILTER_STAY_DATE_UPPER =
  'dynamic_comparisonTimeFilterStayDate_upper';
export const BOOKING_DATE_FILTER_UPPER = 'bookingDateFilter_upper';
export const BOOKING_DATE_FILTER_LOWER = 'bookingDateFilter_lower';
export const COMPARISON_BOOKING_DATE_FILTER_UPPER = 'comparisonBookingDateFilter_upper';
export const COMPARISON_BOOKING_DATE_FILTER_LOWER = 'comparisonBookingDateFilter_lower';
export const COMPARISON_BOOKING_OTB_LOWER = 'comparisonBookingOTB_lower';
export const COMPARISON_BOOKING_OTB_UPPER = 'comparisonBookingOTB_upper';
export const CURRENCY_FILTER = 'currencyFilter';
export const LAST_YEAR_FILTER = 'lastYear';
export const CURRENT_YEAR_FILTER = 'currentYear';
export const YEAR_BEFORE_LAST_YEAR_FILTER = 'yearBeforeLastYear';
export const SELECTED_DATE_FILTER = 'selectedDate';
export const IS_PREDEFINED = 'PreDefined';
export const ANONYMIZED = 'Anonymized';
export const SET_NAME = 'SetName';

export const STAY_DATE_RANGE = 'Stay Date Range';
export const ARRIVAL_DATE_RANGE = 'Arrival Date Range';
export const STAY_DATE_COMPARISON = 'Comparison';
export const BOOKING_DATE_RANGE = 'Booking Date Range';
export const BOOKING_DATE_COMPARISON = 'Comparison';
export const SELECTED_CURRENCY = 'Selected Currency';
export const CURRENCY_COMPARISON = 'Comparison';
export const PMS_SYNC = 'PMS Sync';

export const RATE_COLUMN_INFO_MAP = {
  ADR: 'Average Daily Rate',
  CP: 'Current Period',
  LoS: 'Length of Stay',
  LP: 'Last Period',
  ALT: 'Average Lead Time',
  RN: 'Room Nights',
  TY: 'This Year',
  '% Chg': 'Percentage Change',
  Rsv: 'Reservation',
};

export const BREAKDOWN_COLUMN_INFO_MAP = {
  MTD: 'Month to Date',
  TY: 'This Year',
  YOY: 'Year over Year',
};
// Used to map IATA row names to Cerulean-related columns.
export const EXPORT_CERULEAN_COLUMN_MAPPER = {
  'NEG-CON-IATA': [
    { table: 'measures', columns: 'top_consortia_rates' },
    { table: 'measures', columns: 'top_IATA' },
    { table: 'measures', columns: 'top_negotiated_rates' },
  ],
  'IATA by Rate Codes Detailed': [{ table: 'measures', columns: 'neg_con_iata_detailed' }],
  'Rates By Channel': [{ table: 'measures', columns: 'rates_by_channel' }],
};

export const TOAST_EXPORT_VISUALS_INCOMPLETE =
  'Please expand all visuals and wait for them to fully load before exporting.';
